var $aa8cd83fc8d4982b$exports = {};
$aa8cd83fc8d4982b$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Bira\u{10D} boja`,
    "colorSwatch": `Uzorak boje`,
    "transparent": `providno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};


export {$aa8cd83fc8d4982b$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
